import React, { useEffect, useState, useCallback } from "react";
import { getEmployeeDocuments } from "../../api/employeeDocument";
import { getUser } from "../../utils/Storage";

const EmployeeDocumentView = () => {
  const [documents, setDocuments] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchDocuments = useCallback(async (employeeId) => {
    if (!employeeId) return;

    setLoading(true);

    try {
      const res = await getEmployeeDocuments(employeeId);

      if (res.data?.data && Object.keys(res.data.data).length > 0) {
        setDocuments(res.data.data);
        setError("");
      } else {
        setDocuments(null);
        setError("No documents found");
      }
    } catch (err) {
      setDocuments(null);
      setError("Failed to fetch documents");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const userData = getUser();

    if (userData?.employeeId) {
      fetchDocuments(userData.employeeId);
    }
  }, [fetchDocuments]); // ✅ FIXED

  const formatLabel = (key) =>
    key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());



  return (
    <div className="container-admin" style={{ padding: "20px" }}>
      <h2>Your Documents</h2>
      {loading && <p>Loading documents...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {documents && Object.keys(documents).length > 0 ? (
        <div className="doc-grid" style={{ display: "grid", gap: "20px" }}>
          {Object.entries(documents).map(([key, files]) => {



            // ✅ safety check
            if (!Array.isArray(files) || files.length === 0) return null;

            return (
              <div key={key}>
                <h4>{formatLabel(key)}</h4>

                {files.map((file, index) => {

                  return (
                    <div key={index} style={{ marginBottom: "10px" }}>
                      <a
                        href={file.url}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          display: "inline-block",
                          padding: "6px 12px",
                          backgroundColor: "#007bff",
                          color: "#fff",
                          borderRadius: "4px",
                          textDecoration: "none",
                        }}
                      >
                        View Document {index + 1}
                      </a>

                      <p style={{ fontSize: "12px", color: "#555" }}>
                        Uploaded:{" "}
                        {file.uploadedAt
                          ? new Date(file.uploadedAt).toLocaleString()
                          : "N/A"}
                      </p>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      ) : (
        <p style={{ color: "red" }}>No documents found</p>
      )}
    </div>
  );
};

export default EmployeeDocumentView;